var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('standard-container',{attrs:{"menu-id":"promozioni"}},[_c('v-alert',{attrs:{"outlined":"","text":"","type":"info"}},[_c('div',{staticClass:"title"},[_vm._v("Lavori in corso...")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }